import { REQUEST_SIZE } from 'constants/general';

import { campaignViews } from './constants';

export const queryParamsFactory = (type, formData, sort, channelIds) => {
	return {
		page: 0,
		size: REQUEST_SIZE,
		campaignName: formData.campaignName,
		channelIds: formData.channel,
		campaignStateId: type === campaignViews.PLANED_CAMPAIGNS ? 1 : 2,
		sort,
		...(type === campaignViews.CURRENT_CAMPAIGNS
			? {
					onlyWithContacts: true,
			  }
			: {
					channelIds: [...channelIds],
					onlyAllowedChannels: true,
			  }),
	};
};
